import { render, staticRenderFns } from "./permissionEdit.vue?vue&type=template&id=1caa1950&scoped=true"
import script from "./permissionEdit.vue?vue&type=script&lang=js"
export * from "./permissionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caa1950",
  null
  
)

export default component.exports